import { environment } from '../../environments/environment';

declare var platform: any;
export class AppSettings {
    public static databaseName: string = "prifact.db";
    public static databaseLocation: string = "default";
    public static siteUrl: string = environment.apiUrl;
    public static apiUrl: string = AppSettings.siteUrl + "api/"

    public static SecureStorageCredentials: string = 'PersonCredentials';

    public static SqliteLoggedInPersonKey: string = "LoggedInPerson";
    public static LocalStorageUserContextKey: string = "UserContext";//should be same in AppSettings.cs

    public static ErrorMessageTimeout: number = 5000;

}